import { useEffect, useState } from "react";
import { getProductCreditAsync } from "src/api/credit/credit-api";
import { ProductCredit } from "src/api/credit/credit-types";
import { useApiOperation } from "src/api/hooks";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import { numberToStringWithComma } from "src/utils";

interface IProps {
  productId: string;
}

/**
 * 공간상품 상세 > 요금/관리 > 충전금 관리 섹션 (RPP42 상품 크레딧 조회, 읽기 전용)
 */
const CreditManagementDetail = ({ productId }: IProps) => {
  const { executeAsync: getProductCredit } = useApiOperation(getProductCreditAsync);
  const [credit, setCredit] = useState<ProductCredit>();

  useEffect(() => {
    if (!productId) return;
    (async () => {
      const response = await getProductCredit({ productId });
      setCredit(response?.data?.data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  return (
    <div className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <div className="">
          <BaseSectionTitle title={"충전금 관리"} className="pb10" />
          <ul className="base-list">
            <li>유료 공용공간 예약시 이용 요금만큼 차감되는 결제수단입니다.</li>
            <li>매월 1일 정해진 충전금이 지급되며, 지급된 충전금은 당월 1일부터 말일까지 사용할 수 있습니다.</li>
          </ul>
        </div>
      </div>

      {/* 월별 기본 지급 */}
      <section className="contents-container__grid contents-container__1200">
        <div className="contents-container__grid-index">
          <p>월별 기본 지급</p>
        </div>
        <div className="contents-container__grid-contents">
          <p>{numberToStringWithComma(Number(credit?.monthlyCredit ?? 0))} 원</p>
        </div>
      </section>

      {/* 잔여 충전금 이월 */}
      <section className="contents-container__grid contents-container__1200">
        <div className="contents-container__grid-index">
          <p>잔여 충전금 이월</p>
        </div>
        <div className="contents-container__grid-contents">
          <p>{credit?.isCreditCarryAllowed ? "허용" : "비허용"}</p>
        </div>
      </section>

      {/* 초과 예약 */}
      <section className="contents-container__grid contents-container__1200">
        <div className="contents-container__grid-index">
          <p>초과 예약</p>
        </div>
        <div className="contents-container__grid-contents">
          <p>{credit?.isOverReservationAllowed ? "허용" : "비허용"}</p>
          {/* 후불 정산 한도: 초과 예약 '허용' 시에만 노출 (무제한 / 제한 (n 원)) */}
          {credit?.isOverReservationAllowed && (
            <div className="gray-box mt10">
              <div className="flex-center no-wrap">
                <p className="font-weight-semibold text-primary3 minmax145">후불 정산 한도</p>
                <span className="font14">
                  {credit?.isPostpaidLimited ? `제한 (${numberToStringWithComma(Number(credit?.postpaidLimitAmount ?? 0))} 원)` : "무제한"}
                </span>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default CreditManagementDetail;
